import { useEffect, useRef, useState } from 'react';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityText = ({ text, selectedShapeId, setStageProperties, currentStage, index }) => {
    // References to elements used in the component
    const shapeRef = useRef(null);
    const trRef = useRef(null);
    const inputRef = useRef(null);

    // States for managing text editing
    const [isEditing, setEditing] = useState(false);
    const [editedText, setEditedText] = useState(text.content);
    const [lastText, setLastText] = useState(text.content);
    // Constants defining the maximum dimensions for the text box
    const MAX_WIDTH = 305;
    const MAX_HEIGHT = 462;
    // Effect to handle selecting the shape for editing
    useEffect(() => {
        if (selectedShapeId === text.id) {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [selectedShapeId, text.id]);
    // Function to handle double-click event on the text
    const handleDoubleClick = () => {
        if (text.allowEdit) {
            setEditing(true);
            setLastText(shapeRef.current);
        }
    };
    // Function to update the edited text state
    const handleTextChange = (e) => {
        setEditedText(e.target.value);
    };
    // Function to handle text blur event (losing focus)
    const handleTextBlur = () => {
        setEditing(false);
        updateText();
    };
    // Function to handle key down events (for enter and escape keys)
    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            handleTextBlur(); // Enter key
        } else if (e.keyCode === 27) {
            setEditedText(lastText);
            setEditing(false); // Escape key
        }
    };
    // Function to update the text in the state
    const updateText = () => {
        setStageProperties((prevProperties) => {
            const currentProperties = prevProperties[currentStage];
            const updatedTexts = [...currentProperties.combinedObject];
            updatedTexts[index] = {
                ...updatedTexts[index],
                content: editedText,
            };

            return {
                ...prevProperties,
                [currentStage]: {
                    ...currentProperties,
                    combinedObject: updatedTexts,
                },
            };
        });
    };
    // Function to focus and select all text when the input gains focus
    const handleTextFocus = () => {
        const input = inputRef.current;
        input.setSelectionRange(0, input.value.length);
    };
    return {
        isEditing,
        editedText,
        MAX_WIDTH,
        MAX_HEIGHT,
        shapeRef,
        handleDoubleClick,
        setEditing,
        trRef,
        inputRef,
        handleTextChange,
        handleTextBlur,
        handleTextFocus,
        handleKeyDown,
    };
};
export default FunctionalityText;
